const hostname = window.location.hostname;
// const url = process.env.REACT_APP_API_URL || `http://${hostname}:5004`;
const url = process.env.REACT_APP_API_URL

const ApiConfig = {
  auth: {
    login: `${url}/api/v1/admin/login`,
    sendOtpByMail: `${url}/api/v1/admin/forgetPassword`,
    submitOtpToResetPassword: `${url}/api/v1/admin/submitOtp`,
    resetPassword: `${url}/api/v1/admin/resetPassword/`,
    refreshToken: `${url}/api/v1/admin/refresh-token`,
    updateProfile: `${url}/api/v1/users/updateProfile/`,
    updateProfilePicture: `${url}/api/v1/users/updateUserProfilePicture`,
  },
  course: {
    getAllCourses: `${url}/api/v1/course/getAllCourses`,
    createCourse: `${url}/api/v1/course/create`,
    addCourseDescription: `${url}/api/v1/course/addDescriptionsToCourse`,
    addCourseRequirements: `${url}/api/v1/course/addRequirementsToCourse`,
    createUnit: `${url}/api/v1/course/createUnit`,
    createModule: `${url}/api/v1/course/createModule`,
    addPdfToModule: `${url}/api/v1/course/addPdfContentToModule`,
    addImageToModule: `${url}/api/v1/course/addImageContentToModule`,
    addVideoToModule: `${url}/api/v1/course/addVideoContentToModule`,
    addTextToModule: `${url}/api/v1/course/addTextContentToModule`,
    getCoursePreview: `${url}/api/v1/course/getCourseForPreview`,
    editCreateCourse: `${url}/api/v1/course/editCourseCreate`,
    editCourseDescription: `${url}/api/v1/course/editCourseDesctiption`,
    editCourseRequirements: `${url}/api/v1/course/editCourseRequirements`,
    editUnit: `${url}/api/v1/course/editUnit`,
    editModule: `${url}/api/v1/course/editModule`,
    editVideoContent: `${url}/api/v1/course/editVideoContentInModule`,
    editImageContent: `${url}/api/v1/course/editImageContentInModule`,
    editPdfContent: `${url}/api/v1/course/editPdfContentInModule`,
    editTextContent: `${url}/api/v1/course/editTextContentInModule`,
    getIndividualCourse: `${url}/api/v1/course/getCourseById`,
    getIndividualCourseAfterLogin: `${url}/api/v1/course/getCourseByIdAfterLogin`,
    approvalRequests: `${url}/api/v1/request/getRequestForAdmin`,
    acceptRequest: `${url}/api/v1/request/approveRequestToPublish`,
    declineRequest: `${url}/api/v1/request/declineRequestToPublish`,
    acceptRefundRequest: `${url}/api/v1/users/approveRefundRequest`,
    declineRefundRequest: `${url}/api/v1/users/declinedRefundRequest`,
    unpublishCourse: `${url}/api/v1/course/unpublishCourse`,
    publishCourse: `${url}/api/v1/course/publishCourse`,
    addQuestionsToUnit: `${url}/api/v1/course/addQuestionsToUnit`,
  },
  createCourse: {
    getAllCourses: `${url}/api/v1/course/getAllCourses`,
    createCourse: `${url}/api/v1/course/create`,
    addCourseDescription: `${url}/api/v1/course/addDescriptionsToCourse`,
    addCourseRequirements: `${url}/api/v1/course/addRequirementsToCourse`,
    createUnit: `${url}/api/v1/course/createUnit`,
    createModule: `${url}/api/v1/course/createModule`,
    addPdfToModule: `${url}/api/v1/course/addPdfContentToModule`,
    addImageToModule: `${url}/api/v1/course/addImageContentToModule`,
    addVideoToModule: `${url}/api/v1/course/addVideoContentToModule`,
    addTextToModule: `${url}/api/v1/course/addTextContentToModule`,
    getCoursePreview: `${url}/api/v1/course/getCourseForPreview`,
    editCreateCourse: `${url}/api/v1/course/editCourseCreate`,
    editCourseDescription: `${url}/api/v1/course/editCourseDesctiption`,
    editCourseRequirements: `${url}/api/v1/course/editCourseRequirements`,
    editUnit: `${url}/api/v1/course/editUnit`,
    editModule: `${url}/api/v1/course/editModule`,
    editVideoContent: `${url}/api/v1/course/editVideoContentInModule`,
    editImageContent: `${url}/api/v1/course/editImageContentInModule`,
    editPdfContent: `${url}/api/v1/course/editPdfContentInModule`,
    editTextContent: `${url}/api/v1/course/editTextContentInModule`,
    getAllMajorCategories: `${url}/api/v1/users/getAllMajorCatogeries`,
    getAllSubCategories: `${url}/api/v1/course/getAllSubCategories`,
    createUnitQuiz: `${url}/api/v1/course/addQuestionsToUnit`,
    createCourseQuiz: `${url}/api/v1/course/addFinalAssessmentToCourse`,
    publishCourse: `${url}/api/v1/course/publishCourse`,
    deleteUnit: `${url}/api/v1/course/deleteUnit`,
    deleteUnitQuiz: `${url}/api/v1/course/deleteUnitQuiz`,
    deleteModule: `${url}/api/v1/course/deleteModule`,
    deleteModuleContent: `${url}/api/v1/course/deleteModuleContent`
  },
  dashboard: {
    totalNumberOfCourses: `${url}/api/v1/course/getTotalCourses`,
    totalNumberOfEduPartners: `${url}/api/v1/course/getTotalInstructors`,
    totalNumberOfLearners: `${url}/api/v1/course/getTotalLearners`,
    courseTimeline: `${url}/api/v1/course/getCourseTimeline`,
    getUserFromTopStates: `${url}/api/v1/users/getUsrsFromTopStates`,
    getTopDomains: `${url}/api/v1/course/getTopDomains`,
    getTopEduPartners: `${url}/api/v1/users/getTopEduPartnerListForAdmin`,
    getPlatformRevenue: `${url}/api/v1/users/getPlatformRevenueForAdmin?filter`,
    getActiveStudentsAndPartners: `${url}/api/v1/analytics/getAnalyticsOfActiveStudentsAndEduPartnersForAdmin`
  },
  userManagment: {
    getUserListByRole: `${url}/api/v1/users/getuserlistbyRole?isInstructor=`,
    blockUser: `${url}/api/v1/users/blockUser`,
    unblockUser: `${url}/api/v1/users/unblockUser`,
    getuserbyRole: `${url}/api/v1/users/getuserbyRole`,
    getMyProfile: `${url}/api/v1/users/getMyProfile`,
    getFeedbackGiven: `${url}/api/v1/users/feedbacksGivenByUserOnCourses`,
    getFeedbackReceived: `${url}/api/v1/users/feedbacksGainedOnCoursesOfinstructor`,
    getRevenueAnalytics: `${url}/api/v1/users/getRevenueAnalyticsOfInstructorForAdmin?filter`,
    getLearnerAnalytics: `${url}/api/v1/users/getLearnersAnalyticsOfInstructorForAdmin?filter`,
    deleteFeedbackGiven: `${url}/api/v1/course/deleteReview`,
    instructorCourseTimeline: `${url}/api/v1/course/getCourseTimeLineOfParticularInstructorInAdmin`,
    getTopLocationInstructor: `${url}/api/v1/users/getLearnersFromDifferentStatesFromCoursesOfParticularInstructorInAdmin`,
    updateRevenueShare: `${url}/api/v1/users/updateRevenueShare`
  },
  category: {
    getAllMajorCategories: `${url}/api/v1/users/getAllMajorCatogeries`,
    createCategory: `${url}/api/v1/users/createMajorCategory`,
    editMajorCategory: `${url}/api/v1/users/editMajorCategory`,
  },
  analytics: {
    wishlistConversionRate: `${url}/api/v1/users/getWishlistConversionRate/?filter`,
    newOnboardedUsers: `${url}/api/v1/users/getNewOnboardedUsers/?filter`,
    totalUsersStats: `${url}/api/v1/users/getTotalUsersforStats/?filter`,
    bestSellingCourses: `${url}/api/v1/course/getBestSellingCourses/?filter`,
    cartConversionRate: `${url}/api/v1/users/getCartConversionRate/?filter`,
    latestTransactions: `${url}/api/v1/users/getLatestTransactions/?filter`,
    totalPurchases: `${url}/api/v1/users/getTopPurchases/?filter`,
    topEduPartners: `${url}/api/v1/users/getTopPurchasedEduPartners/?filter`,
    newSignups: `${url}/api/v1/users/getNewSignupsOnPlatform?filter`,
    newPaymentsClosed: `${url}/api/v1/users/getNewPaymentClosed?filter`,
    totalRevenueClosed: `${url}/api/v1/users/getTotalRevenueClosed?filter`,
    newVisitors: `${url}/api/v1/users/getNewVisitors?filter`,
    topSellingCategoryWithFilters: `${url}/api/v1/course/getTopSellingCategoriesForAdmin/?filter`,
    courseCompletionRate: `${url}/api/v1/analytics/getCourseCompletionRate?filter`,
    rewardsAppliedRate: `${url}/api/v1/analytics/getRewardsAppliedRate?filter`,
    resendReceipt: `${url}/api/v1/users/resendReceipt`,
    getInstructorRating: `${url}/api/v1/analytics/instructorRating`,
    overAllRevenueOfInstructor: `${url}/api/v1/analytics/overAllRevenueOfInstructor?filter`,
    learnersOfInstructor: `${url}/api/v1/analytics/getLearnersOfInstrucutor?filter`,
    courseRevenueOfInstructor: `${url}/api/v1/analytics/revenueOfIndividualCourse?filter`,
    totalRevenue: `${url}/api/v1/analytics/getTotalRevenueDifference?filter`,
    learnerCountOfInstructor: `${url}/api/v1/analytics/getLearnersAnalyticsOfInstructor`,
    trackVisitor: `${url}/api/v1/users/trackVisitor`
  },
  account: {
    pendingAccounts: `${url}/api/v1/account/getAccountDetailsWithStatusPending`,
    approveAccount: `${url}/api/v1/account/approveAccount`,
    declineAccount: `${url}/api/v1/account/disapproveAccount`,
    getAllApproveAccounts: `${url}/api/v1/account/getApprovedAccounts`,
    getAllRefund: `${url}/api/v1/course/getRefundRequestForAdmin`
  },
  coupon: {
    createCoupon: `${url}/api/v1/coupon/createCoupon`,
    getCoupon: `${url}/api/v1/coupon/getAllCoupons`,
    activateCoupon: `${url}/api/v1/coupon/activateCoupon`,
    deActivateCoupan: `${url}/api/v1/coupon/deActivateCoupon`,
    editCoupon: `${url}/api/v1/coupon/editCoupon`,
    deleteCoupon: `${url}/api/v1/coupon/deleteCoupon`,
  },
  discounts: {
    createDiscount: `${url}/api/v1/discounts/createDiscount`,
    getDiscounts: `${url}/api/v1/discounts/getAllNonExpiredDiscounts`,
    activateDiscount: `${url}/api/v1/discounts/activateDiscount`,
    deActivateDiscount: `${url}/api/v1/discounts/deActivateDiscount`,
    editDiscount: `${url}/api/v1/discounts/editDiscount`,
    deleteDiscount: `${url}/api/v1/discounts/deleteDiscount`,
  },
  platformSettings: {
    getSettings: `${url}/api/v1/admin/platform-settings`,
    updateSettings: `${url}/api/v1/admin/platform-settings`,
  },
  payout: {
    getAllRequests: `${url}/api/v1/payout/admin/requests`,
    approveRequest: `${url}/api/v1/payout/admin/approve`,
    rejectRequest: `${url}/api/v1/payout/admin/reject`,
    balance: `${url}/api/v1/payout/balance`,
    request: `${url}/api/v1/payout/request`,
    myRequests: `${url}/api/v1/payout/my-requests`,
    onboard: `${url}/api/v1/payout/onboard`
  },
  userProfile: {
    updateUserName: `${url}/api/v1/users/updateProfile/`,
    updateReminders: `${url}/api/v1/users/updateReminderSetting/`,
    updateSocialMediaLinks: `${url}/api/v1/users/updateSocialMediaLinks/`,
    createTestimonial: `${url}/api/v1/testimonial/createTestimonial`,
    getTestimonials: `${url}/api/v1/testimonial/getallTestimonials`,
    sendEmail: `${url}/api/v1/users/contactUsOnEmail`,
    sendEmailBeforeLogin: `${url}/api/v1/users/contactUsOnEmailBeforeLogin`,
    updateProfilePicture: `${url}/api/v1/users/updateUserProfilePicture`,
    updateProfileBanner: `${url}/api/v1/users/updateUserProfileBanner`,
    addInterest: `${url}/api/v1/users/addIntrest`,
    deleteInterest: `${url}/api/v1/users/deleteIntrest`,
    getEnrolledCourses: `${url}/api/v1/users/getEnrolledCourses`,
    getRewardPoints: `${url}/api/v1/users/getRewardPointsOfUser`
  },
  instructor: {
    studentToInstructor: `${url}/api/v1/users/studentBecomeInstructor`,
    register: `${url}/api/v1/users/registerAsInstructor`,
    sendRegisterationOtpByMailInstructor: `${url}/api/v1/users/generateOtpToverifyUserEmail`,
    submitOtpForRegistrationInstructor: `${url}/api/v1/users/submitOtpToVerifyEmailOfInstructor`,
    createTeachingDomain: `${url}/api/v1/onboarding/instructor/createInstructorTeachingDomain`,
    addInstructorPreferredDomain: `${url}/api/v1/onboarding/instructor/addInstructorDomainList`,
    submitProfile: `${url}/api/v1/users/instructor/submitinstructorOnboardingDetails`,
    login: `${url}/api/v1/users/loginAsInstructor`,
    googleOauth: `${url}/api/v1/users/registerwithGmailForInstructor`,
    instructorBecomeStudent: `${url}/api/v1/users/instructorBecomeStudent`,
    studentBecomeInstructor: `${url}/api/v1/users/studentBecomeInstructor`,
    switchToInstructor: `${url}/api/v1/users/switchToInstructor`,
    getDraftCourses: `${url}/api/v1/course/getAllDraftCourses`,
    getPublishedCourses: `${url}/api/v1/course/getAllPublishedCourses`,
    addBankAccount: `${url}/api/v1/account/addBankAccountDetails`,
    uploadCancelCheque: `${url}/api/v1/account/uploadCancelCheque`,
    getBankAccount: `${url}/api/v1/account/getBankAccountDetailsOfUser`,
    deleteBankAccount: `${url}/api/v1/account/deleteBankDetails`,
    getTotalCourseCount: `${url}/api/v1/course/getcountOfCourses`,
    createBio: `${url}/api/v1/users/createUserBio`,
    editBio: `${url}/api/v1/users/editUserBio`,
    getCourseTimeline: `${url}/api/v1/course/getCourseTimelineForInstructor`,
    coursesForApproval: `${url}/api/v1/users/getListOfPendingCoursesForApproval`,
    submitForapproval: `${url}/api/v1/request/createRequest`,
    getInstructorDetails: `${url}/api/v1/users/getInstructorDetails`,
    unpublishCourse: `${url}/api/v1/course/unpublishCourse/`,
    deleteCourse: `${url}/api/v1/course/deleteCourse/`
  },
  notifications: {
    getInstructorNotification: `${url}/api/v1/notification/getAllNotificationsForUser`,
    getLearnerNotification: `${url}/api/v1/notification/getAllNotificationsForLearner`
  },
  adminManagement: {
    manageAdmins: `${url}/api/v1/admin/manage-admins`,
    impersonate: `${url}/api/v1/admin/impersonate`,
  }
};

export default ApiConfig;
